import {
    normalizeFetchAttemptsAnalyticsResponse,
    normalizeFetchCategoriesDistributionByQuestionsAnalyticsResponse,
    normalizeFetchConfidenceDistributionAnalyticsResponse,
    normalizeFetchDistributionBetweenPhasesAnalyticsResponse,
    normalizeFetchGradesPerComponentAnalyticsResponse,
    normalizeFetchGroupsAnalyticsResponse,
    normalizeFetchQuestionsApproveAnalyticsResponse,
    normalizeFetchReviewersApproveAnalyticsResponse,
    normalizeFetchUnitTestsAnalyticsResponse,
} from './utils/normalizers/analytics.normalizers'
import baseApi from './base.api'
import { ANSWER_CATEGORY_TAG, APPROVE_ANALYTICS_TAG, ASSIGNMENT_TAG, SUBMISSION_TAG } from './utils/tags'

export const analyticsApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchGradesPerComponentAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/reports/grades-per-component/${token}`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchGradesPerComponentAnalyticsResponse,
        }),
        fetchAttemptsAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/reports/number-of-attempts/${token}`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchAttemptsAnalyticsResponse,
        }),
        fetchGroupsAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/reports/students-per-group/${token}`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchGroupsAnalyticsResponse,
        }),
        fetchUnitTestsAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/reports/ut-results/${token}`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchUnitTestsAnalyticsResponse,
        }),
        fetchCategoriesDistributionByQuestionsAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/free-text-statistics/${token}/pattern-distribution-by-questions`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchCategoriesDistributionByQuestionsAnalyticsResponse,
            providesTags: [{ type: ANSWER_CATEGORY_TAG, id: 'LIST' }, SUBMISSION_TAG, ASSIGNMENT_TAG],
        }),
        fetchDistributionBetweenPhasesAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/free-text-statistics/${token}/pattern-distribution-between-model-phases`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchDistributionBetweenPhasesAnalyticsResponse,
            providesTags: [{ type: ANSWER_CATEGORY_TAG, id: 'LIST' }, SUBMISSION_TAG, ASSIGNMENT_TAG],
        }),
        fetchConfidenceDistributionAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/free-text-statistics/${token}/confidence-distribution`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchConfidenceDistributionAnalyticsResponse,
            providesTags: [ASSIGNMENT_TAG],
        }),
        fetchQuestionsApproveAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/questions/${token}/approve-diagram`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchQuestionsApproveAnalyticsResponse,
            providesTags: [ASSIGNMENT_TAG, SUBMISSION_TAG, ANSWER_CATEGORY_TAG, APPROVE_ANALYTICS_TAG],
        }),
        fetchReviewersApproveAnalytics: builder.query({
            query: ({ token }) => ({
                url: `/free-text-statistics/${token}/reviewers-progress`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchReviewersApproveAnalyticsResponse,
            providesTags: [ASSIGNMENT_TAG, SUBMISSION_TAG, ANSWER_CATEGORY_TAG, APPROVE_ANALYTICS_TAG],
        }),
    }),
})

export const {
    useFetchGradesPerComponentAnalyticsQuery,
    useFetchAttemptsAnalyticsQuery,
    useFetchGroupsAnalyticsQuery,
    useFetchUnitTestsAnalyticsQuery,
    useFetchCategoriesDistributionByQuestionsAnalyticsQuery,
    useFetchDistributionBetweenPhasesAnalyticsQuery,
    useFetchConfidenceDistributionAnalyticsQuery,
    useFetchQuestionsApproveAnalyticsQuery,
    useFetchReviewersApproveAnalyticsQuery,
} = analyticsApi
